import React from 'react';

const SvgRightCarrot = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M16.2 12l-6.3 6.235V5.765L16.2 12z" />
  </svg>
);

export default SvgRightCarrot;
